export default "assets/images/icons/arrow-d1c08c2e.svg";